import { render } from "./EditLeg.vue?vue&type=template&id=3d45baba&scoped=true"
import script from "./EditLeg.vue?vue&type=script&lang=js"
export * from "./EditLeg.vue?vue&type=script&lang=js"

import "./EditLeg.vue?vue&type=style&index=0&id=3d45baba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d45baba"]])

export default __exports__